// Signing in with a recovery code usually means the phone is gone. The server
// says so on /auth/mfa/verify (`recoveryCodeUsed`, `recoveryCodesLeft`); the
// sign-in remembers it here for this tab, and RecoveryCodeNotice says how many
// are left once the person is in. Kept with whose sign-in it was, so it can
// never show to someone else signing in on the same tab.

const KEY = 'cadence:recovery-code-notice';

export interface RecoveryCodeSignIn {
  userId: string;
  /** Codes left, or null when the server didn't say. */
  left: number | null;
}

/** Called by the sign-in when a recovery code finished it. */
export function rememberRecoveryCodeSignIn(userId: unknown, left: unknown): void {
  if (typeof userId !== 'string' || !userId) return;
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ userId, left: typeof left === 'number' ? left : null }));
  } catch { /* private browsing: no notice */ }
}

/** The remembered sign-in for this person, cleared once read; null when there's none (or it was someone else's). */
export function takeRecoveryCodeSignIn(userId: string | null | undefined): RecoveryCodeSignIn | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    sessionStorage.removeItem(KEY);
    const parsed = JSON.parse(raw) as { userId?: unknown; left?: unknown };
    if (!userId || parsed.userId !== userId) return null;
    return { userId, left: typeof parsed.left === 'number' ? parsed.left : null };
  } catch {
    return null;
  }
}
